import { CombinedVueInstance } from 'vue/types/vue';
import { Component, Mixins } from 'vue-property-decorator';
import PopupComponent from '@/components/messageBox/popup';
import { ROUTE_NAME } from '@/lib/constant';
import router from '@/router';

@Component({
    name: 'FirstDayPopup',
    template: `<MyPopup v-model="value" :content-class="['first-day-popup']" position="center" :modal="true">
        <img class="ticket-slot" v-thumbnail="'/meta/activity_3/popup/first_day/ticket_slot.png'" />
        <div class="ticket-content-wrap">
            <div class="ticket-content" :class="{active: active}" v-thumbnail:background-image="'/meta/activity_3/popup/first_day/ticket_content.png'">
                <MobileButton name="c9c0f1e" class="btn-normal btn-rect" @click="onClick">我 知 道 了</MobileButton>
            </div>
        </div>
        <img class="ticket-content-shadow" v-thumbnail="'/meta/activity_3/popup/first_day/ticket_content_shadow.png'" />
    </MyPopup>`,
})
export class FirstDayPopup extends Mixins(PopupComponent) {
    public active = false;

    /**
     * 点击打卡
     */
    public onClick() {
        this.value = false;
    }
    public mounted() {
        setTimeout(() => {
            this.active = true;
        }, 100);
    }
}

export type FirstDayPopupComponent = CombinedVueInstance<FirstDayPopup, object, object, object, Record<keyof object, any>>;
